import React from 'react'

const ChiefComplaint = ({ widgetUtilities, ...props }) => {
    const { subjectiveData, handleChange} = widgetUtilities;
  return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className='w-100'>
                <p className="heading fs-13 cursor-pointer user-select-none w-max-content">Chief Complaint</p>
                <div className="input mt-1">
                    <div className={"input"}>
                        <textarea
                            className="form-control"
                            // ref={textareaRef}
                            // onInput={adjustTextareaHeight}
                            name="ChiefComplaint"
                            id="ChiefComplaint"
                            autoComplete='off'
                            // placeholder="Add Chief Complaint here..."
                            value={subjectiveData.ChiefComplaint}
                            onChange={(e) => handleChange(e, 'Subjective')}
                        />
                    </div>
                </div>
            </div>
        </div>
  )
}

export default ChiefComplaint